import { visibleRange } from "../../../components/Calendar/utils/date-grid.js";
import { useTabsState } from "../../../hooks/useTabsState.js";
import { aggregateStatusSummaries } from "../activity-evals/instance/status.js";
import { useActivityEvals } from "../hooks/useActivityEvals.js";
import { useServicePeriodInstances } from "../hooks/useServicePeriodInstances.js";
import { buildVisibleRangeQuery } from "./build-visible-range-query.js";
import { calendarEventFromInstance } from "./calendar-event-from-instance.js";
import { ServicePeriodInstancesCalendarView } from "./ServicePeriodInstancesCalendarView.js";
import { useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/calendar/ServicePeriodInstancesCalendar.tsx
var EMPTY_INSTANCES = [];
function ServicePeriodInstancesCalendar({ locationId, locationIds, persistKey, rangeMode = "history", regionIds, renderInstance, servicePeriodIds, timezone }) {
	const scopeKey = locationId ?? locationIds?.join(",") ?? regionIds?.join(",") ?? "all";
	const [view, setView] = useTabsState(persistKey ?? `spcal_${scopeKey}_view`, "month");
	const [anchorMs, setAnchorMs] = useState(() => Date.now());
	const [nowIso] = useState(() => (/* @__PURE__ */ new Date()).toISOString());
	const range = visibleRange(anchorMs, view, timezone);
	const instances = useServicePeriodInstances(buildVisibleRangeQuery({
		fromMs: range.fromMs,
		locationId,
		locationIds,
		nowIso,
		rangeMode,
		regionIds,
		servicePeriodIds,
		toMs: range.toMs
	}));
	const rows = instances.data?.servicePeriodInstances ?? EMPTY_INSTANCES;
	const instanceIds = rows.map((instance) => instance.id);
	const evals = useActivityEvals({
		locationId,
		locationIds,
		regionIds,
		sourceRefIds: instanceIds
	});
	const events = useMemo(() => rows.map((instance) => calendarEventFromInstance(instance, aggregateStatusSummaries((evals.bySourceRefId[instance.id] ?? []).map((item) => item.statusSummary)), nowIso)), [
		evals.bySourceRefId,
		nowIso,
		rows
	]);
	return /* @__PURE__ */ jsx(ServicePeriodInstancesCalendarView, {
		anchorMs,
		error: Boolean(instances.error || evals.error),
		evalsBySourceRefId: evals.bySourceRefId,
		events,
		isLoading: instances.isCalling && !rows.length || evals.isCalling && instanceIds.length > 0,
		onAnchorChange: setAnchorMs,
		onRetry: () => {
			instances.call();
			evals.call();
		},
		onViewChange: (next) => setView(next),
		renderInstance,
		timeZone: timezone,
		view
	});
}
//#endregion
export { ServicePeriodInstancesCalendar };

//# sourceMappingURL=ServicePeriodInstancesCalendar.js.map